import { useState, useCallback } from 'react';
import { FiCopy } from 'react-icons/fi';
import { BsPatchCheckFill } from 'react-icons/bs';
import humanizeKey from 'humanize-key';

interface Props {
  name: string;
}

const COPIED_RESET_MS = 2000;

const ElementRow: React.FC<Props> = ({ name }) => {
  const [copied, setCopied] = useState(false);
  const displayValue = humanizeKey(name);

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (displayValue) {
        navigator.clipboard.writeText(displayValue);
        setCopied(true);
        setTimeout(() => setCopied(false), COPIED_RESET_MS);
      }
    },
    [displayValue],
  );

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    if (displayValue) {
      navigator.clipboard.writeText(displayValue);
      setCopied(true);
      setTimeout(() => setCopied(false), COPIED_RESET_MS);
    }
  };

  return (
    <div className="xa-attributes-list-row">
      <div className="xa-attributes-list-value-group">
        <div
          className="xa-attributes-list-value"
          onContextMenu={handleContextMenu}
          title="Right click to copy"
        >
          {displayValue}
        </div>
        {copied && (
          <span className="xa-attributes-list-copied-notice">Copied!</span>
        )}
        <button
          type="button"
          className="xa-attributes-list-copy-btn"
          onClick={handleCopy}
          title="Copy"
          aria-label="Copy"
        >
          {copied ? (
            <BsPatchCheckFill className="xa-attributes-list-copy-btn-check" />
          ) : (
            <FiCopy />
          )}
        </button>
      </div>
    </div>
  );
};

export default ElementRow;
